import {Injectable} from '@angular/core';
import {ApiService} from './api.service';

@Injectable()
export class PictureService {

  /**
   * Load dependencies
   * @param {ApiService} apiService
   */
  constructor(private apiService: ApiService) {
  }

  /**
   * Fetch an equinox picture by id from the API
   * @param {string} term
   * @returns {Observable<any>}
   */
  getPictureById(term: string) {
    return this.apiService.get('Picture/' + term);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/picture.service.ts